module.exports = __webpack_public_path__ + "img/meal-icon-breakfast.eff93e6b.svg";